// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__3FyJh","breadcrumbItem":"breadcrumb_breadcrumbItem__3LUb_","last":"breadcrumb_last__21hjf","clickable":"breadcrumb_clickable__1nqmj"};